import React from 'react';

export default function Description(props){
    return(
        <div className="desc" id={props.id}>
            <h1>{props.header}</h1>
            <p>{props.paragraph}</p>
        </div>
    )
}